
import { googleAuth } from './googleAuth';

/**
 * Gerenciador de Lembretes - Escopo Restrito: calendar.events
 */
export const createCalendarReminder = async (title: string, dateTime: string, amount: number) => {
  // Fix: replaced non-existent googleAuth.getToken() with awaited googleAuth.getGoogleToken()
  const token = await googleAuth.getGoogleToken();
  if (!token) return false;

  const formattedDateTime = dateTime.includes('T') ? dateTime : `${dateTime}T09:00:00`;
  const start = new Date(formattedDateTime);
  const end = new Date(start.getTime() + 30 * 60000);

  // Payload otimizado para não exigir permissões de escrita de metadados da agenda
  const event = {
    summary: `💰 Lembrete: ${title}`,
    description: `Equilibra Finance: Valor R$ ${amount.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}.\nGerenciado via Nuvem Soberana.`,
    start: { 
      dateTime: start.toISOString(), 
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
    },
    end: { 
      dateTime: end.toISOString(), 
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
    },
    reminders: {
      useDefault: false,
      overrides: [
        { method: 'popup', minutes: 60 },
        { method: 'popup', minutes: 1440 }
      ]
    }
  };

  try {
    const resp = await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/events', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(event)
    });
    
    // Se retornar 403, o escopo no console do Google pode estar errado ou o token expirou
    if (resp.status === 403) {
      console.error("Erro de permissão na Agenda. Verifique se o escopo calendar.events está ativo.");
      return false;
    }
    
    return resp.ok;
  } catch (e) {
    return false;
  }
};

export const createYearlyCardReminders = async (cardName: string, closingDay: number) => {
  // Fix: replaced non-existent googleAuth.getToken() with awaited googleAuth.getGoogleToken()
  const token = await googleAuth.getGoogleToken();
  if (!token) return false;

  const currentYear = new Date().getFullYear();
  const promises = [];

  for (let month = 0; month < 12; month++) {
    const reminderDate = new Date(currentYear, month, closingDay, 9, 0, 0);
    if (reminderDate < new Date()) continue;

    promises.push(
      createCalendarReminder(
        `Fatura: ${cardName}`, 
        reminderDate.toISOString().slice(0, 16), 
        0
      )
    );
  }

  const results = await Promise.all(promises);
  return results.some(r => r === true);
};
